import { useState, useEffect } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "../../api/axios";
import './LoginSignup.css';
import { Helmet } from "react-helmet-async";
import NotFoundPage from "../NotFoundPage/NotFoundPage";

const RegisterInvite = () => {
  const [searchParams] = useSearchParams();
  const invite = searchParams.get("invite");
  const email = searchParams.get("email");
  const navigate = useNavigate();

  const [formData, setFormData] = useState({ name: "", password: "", confirmPassword: "" });
  const [loading, setLoading] = useState(true);
  const [inviteValid, setInviteValid] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);



    
  useEffect(() => {
    // Verify invite token on mount
    const verify = async () => {
      try {
        const res = await axios.post("/api/auth/verify-invite", { invite, email });
        if (res.data.valid) setInviteValid(true);
        else setError("Invalid or expired invite link.");
      } catch {
        setError("Invalid or expired invite link.");
      } finally {
        setLoading(false);
      }
    };
    verify();
  }, [invite, email]);

  const handleChange = e => setFormData(f => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setError("");
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setSubmitting(true);
    try {
        await axios.post("/api/auth/register-invite", {
        invite,
        email,
        name: formData.name,
        username: formData.username, // can be empty
        password: formData.password,
        });

      // Success! Optionally auto-login or redirect
      navigate("/login?registered=1");
    } catch (err) {
      setError(err.response?.data?.error || "Registration failed.");
    }
    setSubmitting(false);
  };

    if (!invite || !email || (loading === false && !inviteValid)) {
    return <NotFoundPage />;
    }


  if (loading) return <div className="auth-container"><p>Checking invite...</p></div>;
  if (!inviteValid) return <div className="auth-container"><p className="error">{error}</p></div>;

  return (
    <>
      <Helmet>
      <title>Admin - Website Name</title>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
      
      <div className="auth-page-wrapper">
        <div className="auth-container">
          <h2>Complete Your Registration</h2>
          {error && <p className="error">{error}</p>}
          <form onSubmit={handleSubmit}>
            <input name="name" type="text" placeholder="Name" value={formData.name} onChange={handleChange} required />
            <input
              name="username"
              type="text"
              placeholder="Username (optional)"
              value={formData.username}
              onChange={handleChange}
              autoComplete="username"
              />

            <input type="email" value={email} disabled />
            <input name="password" type="password" placeholder="Password" onChange={handleChange} required />
            <input name="confirmPassword" type="password" placeholder="Confirm Password" onChange={handleChange} required />
            <button type="submit" disabled={submitting}>{submitting ? "Registering..." : "Register"}</button>
          </form>
        </div>
      </div>
    </>
  );
};
export default RegisterInvite;
